import type { Organisation } from '~/modules/organisations/model'

export const initialOrganisation: Organisation = {
  id: '',
  name: '',
  businessUnitCode: '',
  ccc: {
    customerId: '',
    billingUnitId: '',
  },
  data: {
    address: {
      isBusiness: false,
      countryCode: 'NL',
      postalCode: '',
      city: '',
      street: '',
      houseNumber: '',
      houseNumberSuffix: '',
    },
    contactPerson: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
    },
    chamberOfCommerce: undefined,
    icoNumber: undefined,
    vatNumber: undefined,
  },
  useCompanyAddressBook: false,
  useSharedShipments: false,
  useSharedDrafts: false,
  useAdvancedParcelType: false,
  useSharedTickets: false,
  useSharedImportSchemas: false,
}
